/* This file was automatically generated by tools management permissions. It should not be changed manually. */
import {REG} from "/@lib@/commons/registry.js";
import "/@lib@/core/core_Perms.js";
import "/@lib@/commons/utils/user_Perms.js";

const r = REG.reg;
r.newPerm("action.jobs#delete", "edit.job", 0);
r.newPerm("action.jobs#forceExecute", "edit.job", 0);
r.newPerm("action.jobs#moveInQueue", "edit.job", 0);
r.newPerm("action.jobs#schedule", "edit.job", 0);
r.newPerm("action.users#create.user", "create.user", 0);
r.newPerm("action.users#drop.user", "drop.user", 0);
r.newPerm("action.users#update.user", "update.user", 0);
r.newPerm("action.users#create.group", "create.group", 0);
r.newPerm("action.users#drop.group", "drop.group", 0);
r.newPerm("action.users#update.group", "update.group", 0);
